module.exports = __webpack_public_path__ + "static/media/modal-3.6b5e2e05.jpg";